import React from 'react';
import { UserCircle, Briefcase, Phone, Mail } from 'lucide-react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';

interface ResponsibleFormProps {
  form: {
    full_name: string;
    position: string;
    phone_number: string;
    email: string;
  };
  onChange: (form: any) => void;
  errors: { [key: string]: boolean };
}

const POSITIONS = [
  'Directeur',
  'Gérant',
  'Responsable RH',
  'Responsable recrutement',
  'Autre'
] as const;

export function ResponsibleForm({ form, onChange, errors }: ResponsibleFormProps) {
  const handleChange = (field: string, value: string) => {
    onChange({ ...form, [field]: value });
  };

  const positionOptions = POSITIONS.map(position => ({
    value: position,
    label: position
  }));

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center gap-3 mb-8">
        <div className="p-2 bg-teal-50 rounded-lg">
          <UserCircle className="h-6 w-6 text-teal-600" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900">
          Informations du recruteur
        </h2>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Nom complet
        </label>
        <Input
          type="text"
          value={form.full_name}
          onChange={(e) => handleChange('full_name', e.target.value)}
          error={errors.full_name}
          className="py-2.5"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Poste
        </label>
        <Select
          value={form.position}
          onChange={(e) => handleChange('position', e.target.value)}
          options={positionOptions}
          icon={<Briefcase className="h-5 w-5" />}
          error={errors.position}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Téléphone
          </label>
          <Input
            type="tel"
            value={form.phone_number}
            onPhoneChange={(value) => handleChange('phone_number', value)}
            icon={<Phone className="h-5 w-5" />}
            error={errors.phone_number}
            className="py-2.5"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <Input
            type="email"
            value={form.email}
            onChange={(e) => handleChange('email', e.target.value)}
            icon={<Mail className="h-5 w-5" />}
            error={errors.email}
            className="py-2.5"
            required
          />
           <p className="mt-1 text-xs text-gray-500">
              Cet email ne sera pas visible par les candidats
            </p>
        </div>
      </div>
    </div>
  );
}